export class Empresa {
  cnpj: string;
  razaoSocial: string;
  representantes: Representantes[];
  nomeEmpresa: string;
  necessaryAdjustment?: boolean;
}

export class Representantes {
  nome: string;
  cpf: string;
  emailPj: string;
}
